import api from './api'

class ApartmentsService {
    getApartments(siteId) {
        return api.get(`/sites/${siteId}/apartments`)
    }

    getApartment(apartmentId) {
        return api.get(`/apartments/${apartmentId}`)
    }

    createApartment(apartment) {
        return api.post(`/sites/${apartment.site_id}/apartments`, apartment)
    }

    updateApartment(id, apartment) {
        return api.put(`/apartments/${id}`, apartment)
    }

    deleteApartment(id) {
        return api.delete(`/apartments/${id}`)
    }

    createMoveFile(apartmentId, start, stop, move) {
        return api.get(`/apartments/${apartmentId}/create_move_file`, { params: { start, stop, move } })
    }
}

export default new ApartmentsService()